import * as fromActions from '../actions/efector.action';
import { EfectorData } from '../models/store.model';

export const efectorInitialState: EfectorData | null = null;

export function efectorDataReducer(
    state = efectorInitialState,
    action: fromActions.EfectorDataActions
): EfectorData | null {

    switch (action.type) {

        case fromActions.SETEFECTORDATA:
            return action.efector;

        case fromActions.UNSETEFECTORDATA:
            return efectorInitialState;

        default:
            return state;
    }
}
